import * as React from 'react';
import { ICapacite } from '../models';
import { useData } from '../core/context/ProvidersContext';

export function useCapacites(clientId?: number): {
  capacites: ICapacite[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
} {
  const data = useData();
  const [capacites, setCapacites] = React.useState<ICapacite[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  const refresh = React.useCallback(() => {
    setLoading(true);
    setError(null);
    data.getCapacites(clientId)
      .then(setCapacites)
      .catch((err: Error) => setError(err.message))
      .finally(() => setLoading(false));
  }, [data, clientId]);

  React.useEffect(() => { refresh(); }, [refresh]);

  return { capacites, loading, error, refresh };
}
